import { isType, Action } from "typescript-fsa";
import update from "immutability-helper";
import log from "loglevel";
import { Map } from "immutable";

import { logout } from "@auth/actions";
import { isFailedResponseUnauthenticatedNotLogin } from "@api/actions";
import { StateError, NormalisedResult } from "@orm/models";
import * as actions from "../actions";
import { Chart, ChartsNormalisedEntities, ChartsInternalState as State } from "../models";

const initialState: State = {
    items: Map<string, Chart>(),
    lastLoaded: null,
};

function reducer(state: State = initialState, action: actions.ChartsAction): State {
    // State should never be null...
    if (state === null) {
        log.warn("charts state setting to null, resetting to initialState.");
        state = {} as State;
        state = update(state, { $set: initialState });
    }

    if (isType(action, actions.chartsIndexSuccess)) {
        // Successful chartsIndex
        return chartsIndexSuccess(state, action);
    }
    else if (isType(action, actions.chartsIndexFailure)) {
        // Failed chartsIndex
        return chartsIndexFailure(state, action);
    }
    else if (isType(action, logout) || isFailedResponseUnauthenticatedNotLogin(action)) {
        // Clear the state on logout.
        return update(state, { $set: initialState });
    }
    // Otherwise we do nothing
    return state;
}

function chartsIndexSuccess(
    state: State,
    action: Action<NormalisedResult<string[], ChartsNormalisedEntities>>,
): State {
    const { charts } = action.payload.entities;
    // Replace charts if new ones are found
    const newState = {
        items: charts != null && charts.count() > 0
            ? charts
            : state.items,
        lastLoaded: new Date(),
    } as State;
    return update(state, { $merge: newState });
}

function chartsIndexFailure(state: State, _action: Action<StateError>): State {
    // TODO Handle errors
    const newState = {
    } as State;
    return update(state, { $merge: newState });
}

export { reducer as charts };
